import {createSlice} from "@reduxjs/toolkit";
import {AddAdminUser, DeleteAdminUser, fetchAdminUsers, fetchUsers} from "./Thunks"
import type {IAvailableUsersAvailableUsers as AvailableUser, IGetUsersByGroupGroupsUsers as AdminUser} from "../../../api/generated/models";


export interface AdminsState {
    admins: AdminUser[] | undefined
    users: AvailableUser[] | undefined
}

const initialState: AdminsState = {
    admins: undefined,
    users: undefined,
};

export const AdminsSlice = createSlice({
    name: "Admins",
    initialState,
    reducers: {
        setAdmins: (state, action) => {
            state.admins = action.payload
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchAdminUsers.fulfilled, (state, action) => {
                state.admins = action.payload
            })
            .addCase(fetchUsers.fulfilled, (state, action) => {
                state.users = action.payload
            })
            .addCase(AddAdminUser.fulfilled, (state, action) => {
                if (state.admins && action.payload)
                    state.admins.push(action.payload)
            })
            .addCase(DeleteAdminUser.fulfilled, (state, action) => {
                if (state.admins) {
                    const NewAdmins = state.admins.filter((item) => item.id !== action.payload)
                    if (NewAdmins !== undefined)
                        state.admins = NewAdmins
                }
            })
    }
})

export const { setAdmins } = AdminsSlice.actions;
export default AdminsSlice.reducer
